import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from "react-router-dom";
import App from './App';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
        <BrowserRouter>
            <App/>
        </BrowserRouter>
);

let wmbListener = () => {
};

window.messageBoxListener = cb => wmbListener = cb;

window.messageBox = (txt, cb, isYesNo) => {
    wmbListener(txt, cb, isYesNo);
    // window.dispatchEvent(new CustomEvent('messageBox', {
    //   detail: {
    //     txt,
    //     cb
    //   }
    // }))
};
